import { render, staticRenderFns } from "./ModalFormComponent.vue?vue&type=template&id=34d23c89&scoped=true&"
import script from "./ModalFormComponent.vue?vue&type=script&lang=js&"
export * from "./ModalFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormComponent.vue?vue&type=style&index=0&id=34d23c89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d23c89",
  null
  
)

export default component.exports